import { createRatesService } from './rate.service';

const ENDPOINT = '/api/sme_scheme_rates';
const SMESchemeRatesService = createRatesService(ENDPOINT, 'sme_scheme_rate');

export default SMESchemeRatesService;